export enum Percentile {
  Top5 = 'TOP 1% - 5%',
  Top10 = 'TOP 1% - 10%',
  Top20 = 'TOP 1% - 20%',
  Bottom10 = 'BOTTOM 1% - 10%',
  Bottom20 = 'BOTTOM 1% - 20%',
  BottomNone = 'BOTTOM None',
}
